export const SET_INITIALIZED = 'SetInitialized';
export const ADD_EVENT = 'AddEvent';
export const CLEAR_EVENTS = 'ClearEvents';
export const SCHEDULE_BATCH = 'ScheduleBatch';
export const REMOVE_TIMEOUT = 'RemoveTimeout';
export const SET_OPTIONS = 'SetOptions';
export const SET_LISTENER = 'SetListener';
export const SET_TOKEN = 'SetToken';
export const SET_DEVICE_ID = 'SetDeviceId';
export const SET_SOURCE_APPLICATION = 'SetSourceApplication';
export const SET_LOGGING_API = 'SetLoggingApi';
export const SET_LOGGING_ENABLED = 'SetLoggingEnabled';
export const SET_SEND_BATCH_IN_PROGRESS = 'SetSendBatchInProgress';
